import FetchCommercialUser from "./page/FetchCommercialUser"

const NewRegisterUsers:React.FC =() =>{
    return(
        <>
        <FetchCommercialUser/>
        </>
    )
};
export default NewRegisterUsers;